import { createRouter, createWebHistory } from "vue-router";

import Dashboard from "./pages/dashboard/dashboard-page.vue";
import Dispatch from "./pages/dispatch/dispatch-page.vue";
import Login from './pages/login-page.vue';
import ResetPassword from '~/pages/reset-password/reset-password.vue';
import Forbidden from '~/pages/forbidden-page.vue';
import Preferences from '~/pages/preferences/preferences-page.vue';
import NotFound from '~/pages/not-found-page.vue';
import DeviceDetails from './pages/device-details/device-details-page.vue';
import Register from '~/pages/register/register-page.vue';
import WrongConfiguration from "./pages/wrong-configuration.vue";

import { useAuthStore } from "./store/auth.store";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/group/default/dashboard" },
    { path: "/group/:group/dashboard", component: Dashboard, name: 'dashboard', meta: { requireAuth: true, headbar: true } },
    { path: '/group/:group/stations/:station', component: DeviceDetails, name: 'station-details', meta: { requireAuth: true, headbar: true}},
    { path: "/group/:group/dispatch", component: Dispatch, name: 'dispatch', meta: { requireAuth: true, headbar: true } },
    { path: '/preferences', component: Preferences, name: 'preferences', meta: { requireAuth: true, headbar: true } },
    { path: '/register', component: Register, name: 'register', meta: { requireAuth: false, headbar: false }},
    { path: '/login', component: Login, name: 'login', meta: { requireAuth: false, headbar: false } },
    { path: '/reset-password', component: ResetPassword, name: 'reset-password', meta: { requireAuth: false, headbar: false } },
    { path: '/error', component: WrongConfiguration, name: 'wrong-configuration', meta: { requireAuth: false, headbar: true } },
    { path: '/403', component: Forbidden, name: 'forbidden', meta: { requireAuth: false, headbar: true } },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound, meta: { requireAuth: false, headbar: true } },
  ],
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
});

router.beforeEach((to) => {
  const authStore = useAuthStore();
  if(to.meta.requireAuth && !authStore.isLogged) {
    return '/login'
  }

});

export default router;
